import { isValueDefaultValueOfQuestion } from "@/utils/service/DocumentGeneration";
import refundPolicyQuestions from "./questions_lt_v1";
import {isFalse, isTrue} from "@/utils/service/DocumentGeneration/answers";
import { isArray } from "bootstrap-vue/esm/utils/inspect";
import $log from "@/utils/service/log";
import {toUrl} from "@/utils/textUtilities";
import inputRules from "@/utils/inputRules";

export function transform(data) {
    const goods = {
        non_refundable_goods: (data.non_refundable_goods || []).concat(
            data.non_refundable_goods_other || []
        ) || [],
        required_defective_goods_info: (
            data.required_defective_goods_info || []
        ).concat(data.required_defective_goods_info_other || []) || [],
    }

    if(!Array.isArray(goods.non_refundable_goods)) {
        $log.notify(new Error("non_refundable_goods is not an array"), (event) => {
            event.addMetadata("type", typeof goods.non_refundable_goods);
        })

        goods.non_refundable_goods = []
    }

    if(!Array.isArray(goods.required_defective_goods_info)) {
        $log.notify(new Error("required_defective_goods_info is not an array"), (event) => {
            event.addMetadata("type", typeof goods.required_defective_goods_info);
        })

        goods.required_defective_goods_info = []
    }

    const transformedData = {
        company: data.company,
        website_url: toUrl(data.website_url),
        has_terms_of_services: !!data.has_terms_of_services,
        has_terms_of_services_link: data.has_terms_of_services_link,
        refund_period:
            data.refund_period === "other"
                ? data.refund_period_other
                : data.refund_period,
        refund_issue_period:
            data.refund_issue_period === "other"
                ? data.refund_issue_period_other
                : data.refund_issue_period,
        all_goods_refundable: data.all_goods_refundable,
        some_goods_refundable: data.refundable_goods_type !== 'defective' && !data.all_goods_refundable,
        refundable_goods_type: data.refundable_goods_type,
        return_cost_covered_by_company: data.return_cost_covered_by_company,
        complaint_resolution_methods: data.complaint_resolution_methods,
        ...goods
    };

    let refundProcess = {};

    if (isArray(data.refund_process)) {
        data.refund_process.forEach((value) => {
            refundProcess[value] = true;
        });
    } else {
        refundProcess = data.refund_process;
    }


    if (isTrue(data.has_terms_of_services)) {
        if(data.has_terms_of_services_link === "include_website_tos_from_project") {
            transformedData['include_website_tos_from_project'] = true;
            transformedData.has_terms_of_services_link = "";
        } else {
            transformedData.has_terms_of_services_link = toUrl(data.has_terms_of_services_link);
        }
    } else if (
        isFalse(data.has_terms_of_services) &&
        data.tos_no_use_create &&
        (inputRules.url(data.tos_no_use_create) === true || data.tos_no_use_create === "include_website_tos_from_project")
    ) {
        transformedData.has_terms_of_services = true;
        transformedData.has_terms_of_services_link = toUrl(
            data.tos_no_use_create
        );
        transformedData['include_website_tos_from_project'] = true;
    }

    transformedData["refund_process"] = {
        contact_support: refundProcess.contact_support || false,
        submit_return_form: refundProcess.submit_return_form || false,
        return_to_address: refundProcess.return_to_address || false,
        return_address: data.refund_process_return_address,
        other: data.refund_process_other,
    };

    return transformedData;
}

export function retransform(params) {
    const data = { ...params };

    let final = {};

    // Solve Refund Period
    if (
        isValueDefaultValueOfQuestion(
            data.refund_period,
            "refund_period",
            refundPolicyQuestions
        )
    ) {
        final.refund_period = data.refund_period;
    } else {
        final.refund_period = "other";
        final.refund_period_other = data.refund_period;
    }

    // Solve Refund Issue Period
    if (
        isValueDefaultValueOfQuestion(
            data.refund_issue_period,
            "refund_issue_period",
            refundPolicyQuestions
        )
    ) {
        final.refund_issue_period = data.refund_issue_period;
    } else {
        final.refund_issue_period = "other";
        final.refund_issue_period_other = data.refund_issue_period;
    }

    // Solve Refund Process
    final.refund_process_return_address = {
        ...(data.refund_process.return_address || {}),
    };
    final.refund_process_other = data.refund_process.other;
    const refundProcessCopy = { ...data.refund_process };
    delete refundProcessCopy.return_address;
    delete refundProcessCopy.other;
    final.refund_process = Object.keys(refundProcessCopy).filter(
        (key) => !!refundProcessCopy[key]
    );

    // Solve non_refundable_goods
    final.non_refundable_goods = data.non_refundable_goods.filter((v) =>
        isValueDefaultValueOfQuestion(
            v,
            "non_refundable_goods",
            refundPolicyQuestions
        )
    );
    final.non_refundable_goods_other = data.non_refundable_goods.filter(
        (v) =>
            !isValueDefaultValueOfQuestion(
                v,
                "non_refundable_goods",
                refundPolicyQuestions
            )
    );

    final.refundable_goods_type =
        data.refundable_goods_type === "some" || data.non_refundable_goods.length > 0
            ? "some"
            : "defective";

    // Solve required_defective_goods_info
    final.required_defective_goods_info = data.required_defective_goods_info.filter(
        (v) =>
            isValueDefaultValueOfQuestion(
                v,
                "required_defective_goods_info",
                refundPolicyQuestions
            )
    );
    final.required_defective_goods_info_other = data.required_defective_goods_info.filter(
        (v) =>
            !isValueDefaultValueOfQuestion(
                v,
                "required_defective_goods_info",
                refundPolicyQuestions
            )
    );

    return {
        ...final,
        company: data.company,
        website_url: data.website_url,
        has_terms_of_services: data.has_terms_of_services,
        has_terms_of_services_link: data.has_terms_of_services_link,
        all_goods_refundable: data.all_goods_refundable,
        return_cost_covered_by_company: data.return_cost_covered_by_company,
        complaint_resolution_methods: data.complaint_resolution_methods,
    };
}

